import api from "./api";

const handleApiError = (error, defaultMessage = "Something went wrong") => {
  return (
    error.response?.data || {
      success: false,
      message: defaultMessage,
      data: null
    }
  );
};

export const stockService = {
  // 📦 CREATE STOCK
  createStock: async (stockData) => {
    try {
      const response = await api.post("/create-stock", stockData);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Stock creation failed");
    }
  },

  // 📦 AVAILABLE STOCK
  getAvailableStock: async () => {
    try {
      const response = await api.get("/available-bike");
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to fetch stock");
    }
  },

  // 📦 SHOWROOM STOCK
  getShowroomStock: async () => {
    try {
      const response = await api.get("/available-bike-showroom");
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to fetch showroom stock");
    }
  },

  // 🔄 STOCK TRANSFER
  transferStock: async (data) => {
    try {
      const response = await api.post("/stock-transfer", data);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Stock transfer failed");
    }
  },

  // 🔍 FILTER STOCK
  filterStock: async (params) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/filter-bikes?${query}`);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Filter failed");
    }
  },

  // 🔍 FIND BIKE BY ENGINE
  findBikeByEngine: async (engine) => {
    try {
      const response = await api.get(`/find-bike-details/${engine}`);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Bike not found");
    }
  },

  // 🔍 FIND BIKE BY CHASIS
  findBikeByChasis: async (chasis) => {
    try {
      const response = await api.get(`/find-bike-detail/${chasis}`);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Bike not found");
    }
  },

  // 📊 ENTRY REPORT
  getEntryByDate: async (date) => {
    try {
      const response = await api.get(`/find-entry-bike-details/${date}`);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },

  getWeeklyEntry: async (year) => {
    try {
      const response = await api.get(`/find-entry-bike-weekly-details/${year}`);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },

  getMonthlyEntry: async (year) => {
    try {
      const response = await api.get(`/find-entry-bike-monthly-details/${year}`);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },

  // 📦 MODELS
  getAllModels: async () => {
    try {
      const response = await api.get("/find-all-model-name-in-stock");
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },

  getModelDistribution: async (model) => {
    try {
      const response = await api.get(
        `/find-no-of-bike-same-model-diff-place-in-stock/${model}`
      );
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },

  // 🔐 PASSWORD VERIFY
  verifyPassword: async (type, password) => {
    try {
      const response = await api.post("/verify-password", { type, password });
      return response.data;
    } catch (error) {
      return handleApiError(error, "Password verification failed");
    }
  },

  // ✏️ UPDATE STOCK
  updateStock: async (stockData) => {
    try {
      const response = await api.put("/update-stock-bike", stockData);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Stock update failed");
    }
  }
};